export interface LegalDocumentRenderInput {
    legalDocumentContentType: string;
    legalDocumentText: string;
}

function escapeHtmlText(value: string): string {
    return value
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
}

export function buildLegalDocumentIframeSrcDoc(input: LegalDocumentRenderInput): string {
    // Tolerate parameters such as "text/html; charset=utf-8".
    const contentType: string = (input.legalDocumentContentType.split(';')[0] ?? '')
        .trim()
        .toLowerCase();
    const rawText: string = input.legalDocumentText;

    const bodyHtml: string =
        contentType === 'text/html' || contentType === 'application/xhtml+xml'
            ? rawText
            : contentType === 'text/plain'
              ? `<pre style="white-space: pre-wrap; font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;">${escapeHtmlText(rawText)}</pre>`
              : `<p role="alert">This document is stored as ${escapeHtmlText(contentType)}, which cannot be displayed. Contact support.</p>`;

    return `<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      body { margin: 0; padding: 16px; font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji"; }
    </style>
  </head>
  <body>
    ${bodyHtml}
  </body>
</html>`;
}
